<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Claim Sub Type Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination"
          item-key="clmType+':'+clmSubType" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="items" slot-scope="props">
            <td>{{ appDesc(props.item.appId) }}</td>
            <td>{{ props.item.clmType }}</td>
            <td>{{ props.item.seqNo }}</td>
            <td>{{ props.item.clmSubType }}</td>
            <td>{{ props.item.clmSubTypeDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['claimReview'])" @review="doReview(props.item)" remove @remove="doPromptRemove(props.item)"
                query @query="doQuery(props.item)" />
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Claim Sub Type
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="showClmSubTypeDialog" width="800px" v-if="checkAccess(['claimReview'])" persistent>
        <clm-sub-type-dialog :selectedClmSubType="selectedClmSubType" :mode="mode" @close="showClmSubTypeDialog = false" @fetchData="fetchData"/>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove" title="Claim Type">
        Are you sure that you want to remove the selected claim sub type? (<b>{{deleteClmSubType.clmType}} - {{deleteClmSubType.clmSubType}}</b>)
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import { appIDDesc } from '@/const/underwriting'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import ClmSubTypeDialog from './ClmSubTypeDialog'

export default {
  data() {
    return {
      loading: false,
      search: '',
      headers: [
        { text: 'Module', align: 'left', value: 'appId' },
        { text: 'Claim Type', align: 'left', value: 'clmType' },
        { text: 'Seq No', align: 'left', value: 'seqNo' },
        { text: 'Claim Sub Type', align: 'left', value: 'clmSubType' },
        { text: 'Claim Sub Type Description', align: 'left', value: 'clmSubTypeDesc' },
        TableConst.tableActionHeader
      ],
      mode: '',
      selectedClmSubType: {
        appId: '',
        clmType: '',
        clmSubType: '',
        clmSubTypeDesc: '',
        seqNo: '',
        permMultiClmt: false
      },
      deleteClmSubType: {},
      showClmSubTypeDialog: false,
      promptRemove: false
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.claimParam.menu.getClmSubTypes
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = data
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Unable to retrieve claim sub types (Missing API URL)')
      }
      this.loading = false
    },
    doNew() {
      this.selectedClmSubType.appId = ''
      this.selectedClmSubType.clmType = ''
      this.selectedClmSubType.clmSubType = ''
      this.selectedClmSubType.clmSubTypeDesc = ''
      this.selectedClmSubType.seqNo = 1
      this.selectedClmSubType.permMultiClmt = false
      this.mode = 'new'
      this.showClmSubTypeDialog = true
    },
    doReview(clmSubType) {
      this.selectedClmSubType.appId = clmSubType.appId
      this.selectedClmSubType.clmType = clmSubType.clmType
      this.selectedClmSubType.clmSubType = clmSubType.clmSubType
      this.selectedClmSubType.clmSubTypeDesc = clmSubType.clmSubTypeDesc
      this.selectedClmSubType.seqNo = clmSubType.seqNo
      this.selectedClmSubType.permMultiClmt = clmSubType.permMultiClmt
      this.mode = 'review'
      this.showClmSubTypeDialog = true
    },
    doQuery(clmSubType) {
      this.selectedClmSubType.appId = clmSubType.appId
      this.selectedClmSubType.clmType = clmSubType.clmType
      this.selectedClmSubType.clmSubType = clmSubType.clmSubType
      this.selectedClmSubType.clmSubTypeDesc = clmSubType.clmSubTypeDesc
      this.selectedClmSubType.seqNo = clmSubType.seqNo
      this.selectedClmSubType.permMultiClmt = clmSubType.permMultiClmt
      this.mode = 'query'
      this.showClmSubTypeDialog = true
    },
    doPromptRemove(clmSubType) {
      this.deleteClmSubType = clmSubType
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.$store.state.claimParam.menu.deleteClmSubType
      if (apiURI) {
        this.loading = true
        const expand = {
          appId: this.deleteClmSubType.appId,
          clmType: this.deleteClmSubType.clmType,
          clmSubType: this.deleteClmSubType.clmSubType
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    appDesc(appID) {
      return appIDDesc[appID]
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  components: {
    ClmSubTypeDialog: ClmSubTypeDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
